(function () {
  'use strict';

  angular.module('app').component('providerAssociatedProducts', providerAssociatedProducts());

  function providerAssociatedProducts() {
    return {
      bindings: {
        provider: '=',
        associatedProducts: '=',
        onAssociatedProductSaved: '&',
        onAssociatedProductDeleted: '&',
        defaultLanguage: '<',
      },
      controller: ProviderAssociatedProductsComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/providers/components/provider-associated-products/provider-associated-products.component.html',
    };
  }

  ProviderAssociatedProductsComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$location',
    'ProviderService',
    'TourService',
    'TransportationService',
    'HotelService',
    'ServiceItemService',
    'ServiceItemCostService',
    'PackageService',
  ];

  function ProviderAssociatedProductsComponent(
    config,
    UtilService,
    $location,
    ProviderService,
    TourService,
    TransportationService,
    HotelService,
    ServiceItemService,
    ServiceItemCostService,
    PackageService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.productTypes = vm.UtilService.getProductTypes();

    vm.productTypeLabel = 'SELECT';

    var fieldsDefinition = ['provider_product_code'];

    // Methods
    vm.showAssociatedProduct = showAssociatedProduct;
    vm.addAssociatedProduct = addAssociatedProduct;
    vm.editAssociatedProduct = editAssociatedProduct;
    vm.removeAssociatedProduct = removeAssociatedProduct;
    vm.changeAssociatedProductStatus = changeAssociatedProductStatus;
    vm.deleteAssociatedProduct = deleteAssociatedProduct;
    vm.saveAssociatedProduct = saveAssociatedProduct;

    vm.openProductCostsModal = openProductCostsModal;
    vm.selectProducType = selectProducType;

    function getTours() {
      if (vm.tours) {
        getAvailableProductsByType(vm.tours);

        return;
      }

      vm.loadingProducts = true;
      TourService.getTours({ get: 'selector', skip_check_role: true }).then(function (data) {
        vm.tours = data.items;
        getAvailableProductsByType(vm.tours);

        vm.loadingProducts = false;
      });
    }

    function getTransportations() {
      if (vm.transportations) {
        getAvailableProductsByType(vm.transportations);

        return;
      }

      vm.loadingProducts = true;
      TransportationService.getTransportations({ get: 'selector', skip_check_role: true }).then(
        function (data) {
          vm.transportations = data.items;
          getAvailableProductsByType(vm.transportations);

          vm.loadingProducts = false;
        }
      );
    }

    function getHotels() {
      if (vm.hotels) {
        getAvailableProductsByType(vm.hotels);

        return;
      }

      vm.loadingProducts = true;
      HotelService.getHotels({ get: 'selector', skip_check_role: true }).then(function (data) {
        vm.hotels = data.items;
        getAvailableProductsByType(vm.hotels);

        vm.loadingProducts = false;
      });
    }

    function getServiceItems() {
      if (vm.serviceItems) {
        getAvailableProductsByType(vm.serviceItems);

        return;
      }

      vm.loadingProducts = true;
      ServiceItemService.getServiceItems({ get: 'selector', skip_check_role: true }).then(function (
        data
      ) {
        vm.serviceItems = data.items;
        getAvailableProductsByType(vm.serviceItems);

        vm.loadingProducts = false;
      });
    }

    function getPackages() {
      if (vm.packages) {
        getAvailableProductsByType(vm.packages);

        return;
      }

      vm.loadingProducts = true;
      PackageService.getPackages({ get: 'selector', skip_check_role: true }).then(function (data) {
        vm.packages = data.items;
        getAvailableProductsByType(vm.packages);

        vm.loadingProducts = false;
      });
    }

    function selectProducType(productSetting) {
      productSetting.product_id = null;

      var label;

      switch (productSetting.product_type) {
        case 'tour':
          getTours();
          label = 'SELECT_TOUR';
          break;
        case 'transportation':
          getTransportations();
          label = 'SELECT_TRANSPORTATION';
          break;
        case 'hotel':
          getHotels();
          label = 'SELECT_HOTEL';
          break;
        case 'service_item':
          getServiceItems();
          label = 'SELECT_ITEM';
          break;
        case 'package':
          getPackages();
          label = 'SELECT_PACKAGE';
          break;
      }

      vm.productTypeLabel = label;
    }

    function getAvailableProductsByType(products) {
      var associatedProducts = setAssociatedProducts(vm.associatedProducts);

      vm.availableProductsByType = vm.UtilService.getAvailableItemsInTwoArrays(
        products,
        associatedProducts,
        'id'
      );
    }

    function setAssociatedProducts(associatedProducts) {
      var productIds = [];
      associatedProducts.forEach(function (associatedProduct) {
        if (associatedProduct.product) {
          productIds.push({
            id: associatedProduct.product.id,
            name: associatedProduct.product.name,
          });
        }
      });

      return productIds;
    }

    function showAssociatedProduct(associatedProduct) {
      const product = vm.UtilService.setProductType(associatedProduct);

      $location.path(`/${product.model}/${associatedProduct.product.id}`);
    }

    function addAssociatedProduct() {
      vm.addMode = true;
      vm.associatedProducts.push({});
    }

    function editAssociatedProduct(associatedProduct) {
      associatedProduct.editMode = !associatedProduct.editMode;

      if (!associatedProduct.editMode) {
        // Undo changes
        _restoreOriginalValues(associatedProduct);
      } else {
        // save server name to restore it if the user cancel edition
        associatedProduct.originalValues = angular.toJson(associatedProduct);
      }
    }

    function _restoreOriginalValues(associatedProduct) {
      var serverItem = angular.fromJson(associatedProduct.originalValues);

      fieldsDefinition.forEach(function (field) {
        associatedProduct[field] = serverItem[field];
      });
    }

    function removeAssociatedProduct(index) {
      vm.addMode = false;
      vm.availableProductsByType = null;

      vm.associatedProducts.splice(index, 1);
    }

    function changeAssociatedProductStatus(associatedProduct) {
      ProviderService.changeAssociatedProductStatus(associatedProduct, vm.provider.id);
    }

    function deleteAssociatedProduct(associatedProduct) {
      var successCallback = function () {
        var index = vm.associatedProducts.indexOf(associatedProduct); // To work with orderBy

        removeAssociatedProduct(index);

        vm.onAssociatedProductSaved({ items: vm.associatedProducts });
      };

      ProviderService.deleteAssociatedProduct(associatedProduct, vm.provider.id, successCallback);
    }

    // Create/Update
    function saveAssociatedProduct(associatedProduct, isFormValid) {
      associatedProduct.serverErrors = [];

      if (isFormValid) {
        if (!associatedProduct.editMode) {
          // Create
          associatedProduct.provider_id = vm.provider.id;
          associatedProduct[associatedProduct.product_type + '_id'] = associatedProduct.product_id;
        }

        var item = {
          id: associatedProduct.id,
          product_type: associatedProduct.product_type,
          [associatedProduct.product_type + '_id']:
            associatedProduct[associatedProduct.product_type + '_id'],
          provider_product_code: associatedProduct.provider_product_code,
          provider_id: associatedProduct.provider_id,
        };

        vm.sendingForm = true;
        ProviderService.saveAssociatedProduct(item, vm.provider.id).then(function (data) {
          if (!data.errors) {
            // Success
            // !important as we are sending a item object
            associatedProduct.id = data.id;
            associatedProduct.status = data.status;
            associatedProduct.product = data.product;

            vm.onAssociatedProductSaved({ items: vm.associatedProducts });

            vm.availableProductsByType = null;

            associatedProduct.editMode = false;
            delete associatedProduct.originalValues;
          } else {
            associatedProduct.serverErrors = vm.UtilService._showItemServerErrors(data.errors);
          }

          vm.addMode = false;
          vm.sendingForm = false;
        });
      }
    }

    function openProductCostsModal(associatedProduct) {
      // For service item only
      let successCallback = (dataObj) => {
        associatedProduct.product.current_costs = {
          rates_today: dataObj.rates_today,
          rates_updated_until: dataObj.rates_updated_until,
          currency: dataObj.currency,
        };
      };

      switch (associatedProduct.product_type) {
        case 'tour':
          // $location.go('user.tour_overview', { id: associatedProduct.product.id, activeTab: 4 });
          $location.path(`/tours/${associatedProduct.product.id}`).search({ activeTab: 5 });
          break;
        case 'transportation':
          // $location.go('user.transportation_overview', {
          //   id: associatedProduct.product.id,
          //   activeTab: 4,
          // });
          $location
            .path(`/transportation/${associatedProduct.product.id}`)
            .search({ activeTab: 5 });
          break;
        case 'hotel':
          // $location.go('user.hotel_overview', { id: associatedProduct.product.id, activeTab: 4 });
          $location.path(`/hotels/${associatedProduct.product.id}`).search({ activeTab: 5 });
          break;
        case 'service_item':
          ServiceItemCostService.openServiceItemCostsModal(
            associatedProduct.product,
            vm.provider,
            'provider',
            vm.defaultLanguage,
            successCallback
          );
          break;
        case 'package':
          // $location.go('user.package_overview', { id: associatedProduct.product.id, activeTab: 4 });
          $location.path(`/packages/${associatedProduct.product.id}`).search({ activeTab: 5 });
          break;
      }
    }
  }
})();
